var map = {
	"./AutoLogout.svg": "./src/components/CompanyAdmin/frontend-common/images/AutoLogout.svg",
	"./CheckCircleIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/CheckCircleIcon.svg",
	"./CheckIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/CheckIcon.svg",
	"./CopyToken.svg": "./src/components/CompanyAdmin/frontend-common/images/CopyToken.svg",
	"./CustomCheck.svg": "./src/components/CompanyAdmin/frontend-common/images/CustomCheck.svg",
	"./DomainWhitelist.svg": "./src/components/CompanyAdmin/frontend-common/images/DomainWhitelist.svg",
	"./InfoIconFilled.svg": "./src/components/CompanyAdmin/frontend-common/images/InfoIconFilled.svg",
	"./LoginMethods.svg": "./src/components/CompanyAdmin/frontend-common/images/LoginMethods.svg",
	"./PasswordExpiry.svg": "./src/components/CompanyAdmin/frontend-common/images/PasswordExpiry.svg",
	"./PaymentFail.svg": "./src/components/CompanyAdmin/frontend-common/images/PaymentFail.svg",
	"./PaymentSuccess.svg": "./src/components/CompanyAdmin/frontend-common/images/PaymentSuccess.svg",
	"./SecurityAutoLogout.svg": "./src/components/CompanyAdmin/frontend-common/images/SecurityAutoLogout.svg",
	"./SecurityDomain.svg": "./src/components/CompanyAdmin/frontend-common/images/SecurityDomain.svg",
	"./SecurityLogin.svg": "./src/components/CompanyAdmin/frontend-common/images/SecurityLogin.svg",
	"./SecurityPasswordExpiry.svg": "./src/components/CompanyAdmin/frontend-common/images/SecurityPasswordExpiry.svg",
	"./Star.svg": "./src/components/CompanyAdmin/frontend-common/images/Star.svg",
	"./addressIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/addressIcon.svg",
	"./cibilCreditScoreIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/cibilCreditScoreIcon.svg",
	"./confirmationSymbol.svg": "./src/components/CompanyAdmin/frontend-common/images/confirmationSymbol.svg",
	"./courtRecordIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/courtRecordIcon.svg",
	"./dropdownArrow.svg": "./src/components/CompanyAdmin/frontend-common/images/dropdownArrow.svg",
	"./drugIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/drugIcon.svg",
	"./educationIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/educationIcon.svg",
	"./emailBouncedIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/emailBouncedIcon.svg",
	"./employmentIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/employmentIcon.svg",
	"./freshworks.png": "./src/components/CompanyAdmin/frontend-common/images/freshworks.png",
	"./greenhouse.png": "./src/components/CompanyAdmin/frontend-common/images/greenhouse.png",
	"./hourglass.svg": "./src/components/CompanyAdmin/frontend-common/images/hourglass.svg",
	"./icons8-gmail-240.svg": "./src/components/CompanyAdmin/frontend-common/images/icons8-gmail-240.svg",
	"./icons8-whatsapp-240.svg": "./src/components/CompanyAdmin/frontend-common/images/icons8-whatsapp-240.svg",
	"./identityIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/identityIcon.svg",
	"./info.svg": "./src/components/CompanyAdmin/frontend-common/images/info.svg",
	"./inkle.jpg": "./src/components/CompanyAdmin/frontend-common/images/inkle.jpg",
	"./keka.png": "./src/components/CompanyAdmin/frontend-common/images/keka.png",
	"./leftArrow.svg": "./src/components/CompanyAdmin/frontend-common/images/leftArrow.svg",
	"./lever.png": "./src/components/CompanyAdmin/frontend-common/images/lever.png",
	"./lock.svg": "./src/components/CompanyAdmin/frontend-common/images/lock.svg",
	"./lockGreyColor.png": "./src/components/CompanyAdmin/frontend-common/images/lockGreyColor.png",
	"./lockKeyhole.png": "./src/components/CompanyAdmin/frontend-common/images/lockKeyhole.png",
	"./lock_guard_blue.svg": "./src/components/CompanyAdmin/frontend-common/images/lock_guard_blue.svg",
	"./lock_guard_white.svg": "./src/components/CompanyAdmin/frontend-common/images/lock_guard_white.svg",
	"./lowPackageUnit.svg": "./src/components/CompanyAdmin/frontend-common/images/lowPackageUnit.svg",
	"./nillPackageUnit.svg": "./src/components/CompanyAdmin/frontend-common/images/nillPackageUnit.svg",
	"./orderSent.svg": "./src/components/CompanyAdmin/frontend-common/images/orderSent.svg",
	"./razorPayX.png": "./src/components/CompanyAdmin/frontend-common/images/razorPayX.png",
	"./recruitee.png": "./src/components/CompanyAdmin/frontend-common/images/recruitee.png",
	"./referenceIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/referenceIcon.svg",
	"./reset.png": "./src/components/CompanyAdmin/frontend-common/images/reset.png",
	"./rippling.png": "./src/components/CompanyAdmin/frontend-common/images/rippling.png",
	"./scrut.jpg": "./src/components/CompanyAdmin/frontend-common/images/scrut.jpg",
	"./sprinto.png": "./src/components/CompanyAdmin/frontend-common/images/sprinto.png",
	"./star.png": "./src/components/CompanyAdmin/frontend-common/images/star.png",
	"./warning.svg": "./src/components/CompanyAdmin/frontend-common/images/warning.svg",
	"./warningPackage.svg": "./src/components/CompanyAdmin/frontend-common/images/warningPackage.svg",
	"./warningRed.svg": "./src/components/CompanyAdmin/frontend-common/images/warningRed.svg",
	"./warningRedIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/warningRedIcon.svg",
	"./worldIcon.svg": "./src/components/CompanyAdmin/frontend-common/images/worldIcon.svg",
	"./zoho_recruit.png": "./src/components/CompanyAdmin/frontend-common/images/zoho_recruit.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/CompanyAdmin/frontend-common/images sync recursive ^\\.\\/.*$";